import { Route } from 'react-router';
import ErrorBoundary from './ErrorBoundary';
import RouteError from './RouteError';

export default function PageRoute({ render, ...props }) {
    return (
        <Route
            {...props}
            render={(...renderProps) => (
                <ErrorBoundary errorComponent={RouteError}>{render(...renderProps)}</ErrorBoundary>
            )}
        />
    );
}
